// import acmEncode from './acm-encode'
import iconfont from './iconfont'
// import apiEncode from './api-encode'
// import mixEncode from './mix-encode'
// eslint-disable-next-line no-unused-vars
import { Decrypt, Encrypt } from '@/utils/aes'

import acm from './acm'
import api from './api'
import mix from './mix'

export default
  // iconfont.apiConfig
  //   .concat(JSON.parse(Decrypt(acmEncode)))
  //   .concat(JSON.parse(Decrypt(apiEncode)))
  //   .concat(JSON.parse(Decrypt(mixEncode)))
  iconfont.apiConfig
    .concat(acm.apiConfig)
    .concat(api.apiConfig)
    .concat(mix.apiConfig)
